import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Verdict from "./components/Verdict";
import Features from "./components/Features";
import Tutorial from "./components/Tutorial";
import Guides from "./components/Guides";
import Reviews from "./components/Reviews";
import Faq from "./components/Faq";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import BackToTop from "./components/BackToTop";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50 text-foreground-900">
      <Navbar />
      <main>
        <Hero />
        <Verdict />
        <Features />
        <Tutorial />
        <Guides />
        <Reviews />
        <Faq />
        <Contact />
      </main>
      <Footer />
      <BackToTop />
    </div>
  );
}